import React, { useState } from "react";
import {
  Box,
  Button,
  Col,
  Dialog,
  FabButton,
  Flex,
  Icon,
  InputField,
  Row,
  Typography,
} from "../../../../ppui";
import { AllowanceBox } from "../../../../pages/style";
import { TbAlertTriangle, TbPencil } from "react-icons/tb";
import useLeaveService from "./leave-service";
import { LEAVE_INITIAL_STATE } from "./leave-constant";
import { logger } from "../../../../utils/logger";

const AdminLeaveManagement = ({ openSnackbar }) => {
  const {
    leaveListinfo,
    leave,
    handleChange,
    handleBlurFn,
    errors,
    setLeave,
    setErrors,
    handleSubmit,
    handleUpdate,
    leaveLists,
    pagination
  } = useLeaveService({ openSnackbar });

  const [open, setOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editLeaveId, setEditLeaveId] = useState(null);

  const handleClickOpen = () => {
    setLeave(LEAVE_INITIAL_STATE);
    setOpen(true);
    setErrors({});
    setIsEditMode(false);
  };
  const handleEditModalOpen = (data) => {
    setLeave(data);
    setOpen(true);
    setEditLeaveId(data.leave_type_id);
    setErrors({});
    setIsEditMode(true);
  };

  const handleClose = () => {
    setOpen(false);
    setLeave(LEAVE_INITIAL_STATE);
    setErrors({});
  };

  const handleSubmitFn = async () => {
    // const hasErrors = Object.values(errors).some((error) => error !== undefined);
    let success = false;
    if (editLeaveId) {
     success =  await handleUpdate(editLeaveId);
    } else {
      success = await handleSubmit();
    }
    logger.log(success, "dipronil")
    if (!success) {
      setOpen(true);
    } else{
      setOpen(false);
    }
  };

  const handlePagination = (direction) => {
    const nextPage = direction === "next" ? pagination.page + 1 : pagination.page - 1;
    if (nextPage > 0 && nextPage <= pagination.totalPages) {
        leaveLists(nextPage, pagination.pageSize);
    }
  };

  return (
    <>
      <Flex justifyContent="space-between" mb={18} gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          Leave Management
        </Typography>
        <Button onClick={handleClickOpen} variant="outlined" size="sm">
          Create New
        </Button>
      </Flex>

      {leaveListinfo.length === 0 ? (
        <AllowanceBox mb={20}>
          <Icon color={"danger"} size={"lg"}>
            <TbAlertTriangle />
          </Icon>
          <Typography
            variant="body1"
            display="flex"
            gap={10}
            alignItems="center"
            mb={0}
            p={15}
          >
            No predefined Leave Management data available.
          </Typography>
        </AllowanceBox>
      ) : (
        <>
          <Flex gap={20} direction="column">
            {leaveListinfo.map((data) => (
              <AllowanceBox key={data.id} mb={20}>
                <Row alignItems="center">
                  <Col xs={11}>
                    <Flex alignItems="center" gap={{ md: 20, lg: 40, xxl: 60 }}>
                      <Box>
                        <Box className="label">Leave Name</Box>
                        <Box className="value">{data.leave_type_name}</Box>
                      </Box>
                    </Flex>
                  </Col>

                  <Col xs={1}>
                    <Box>
                      <FabButton
                        size="sm"
                        icon={<TbPencil />}
                        onClick={() => handleEditModalOpen(data)}
                        variant="filled"
                        shape="box"
                      />
                    </Box>
                  </Col>
                </Row>
              </AllowanceBox>
            ))}
          </Flex>
          <Box mt={20}>
            <Flex alignItem="center" justifyContent="center" gap={10}>
              <Button
                color="default"
                colorvariant="main"
                variant="outlined"
                size="sm"
                disabled={pagination.page === 1}
                onClick={() => handlePagination("previous")}
              >
                Previous
              </Button>
              <Typography
                variant="body2"
                mb="0"
                color="dark"
                colorvariant="light"
              >
                  Page {pagination.page} of {pagination.totalPages}
              </Typography>
              <Button
                color="default"
                colorvariant="main"
                variant="outlined"
                size="sm"
                disabled={pagination.page === pagination.totalPages}
                onClick={() => handlePagination("next")}
              >
                Next
              </Button>
            </Flex>
          </Box>
        </>
      )}

      {/* Create Allowance */}
      <Dialog
        title={isEditMode ? "Update Leave" : "Create Leave"}
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmitFn}
        separator
        bodyScroll={true}
      // footer={
      //   <>
      //   <Box mr={"auto"}>
      //   <Checkbox size="sm" color="primary" label="Add another leave" />
      //   </Box>

      //   </>
      // }
      >
        <Row rowGap={20}>
          <Col sm={12} md={6}>
            <InputField
              required
              fullWidth
              label="Leave Type"
              type="text"
              placeholder="Type Here"
              valueSinc={!!leave.leave_type_name}
              value={leave.leave_type_name}
              onChange={(e) => handleChange(e.target.value, "leave_type_name")}
              helperText={errors.leave_type_name}
              error={errors.leave_type_name}
              onBlur={(e) => handleBlurFn(e, "leave_type_name")}
            />
          </Col>
        </Row>
      </Dialog>
      {/* Create Allowance */}
    </>
  );
};

export default AdminLeaveManagement;
